var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        disabled: _vm.disabled,
        placement: _vm.placement,
        width: "300",
        "popper-class": "no-padding-popover",
        trigger: "click",
      },
      model: {
        value: _vm.showPopover,
        callback: function ($$v) {
          _vm.showPopover = $$v
        },
        expression: "showPopover",
      },
    },
    [
      !_vm.disabled
        ? _c(
            "xh-user",
            _vm._b(
              {
                directives: [
                  {
                    name: "elclickoutside",
                    rawName: "v-elclickoutside",
                    value: _vm.handleClose,
                    expression: "handleClose",
                  },
                ],
                ref: "xhuser",
                attrs: {
                  show: _vm.showPopover,
                  "selected-data": _vm.dataValue,
                  radio: _vm.radio,
                },
                on: { changeCheckout: _vm.checkUsers },
              },
              "xh-user",
              _vm.$attrs,
              false
            )
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.$slots.reference
        ? _c(
            "flexbox",
            {
              ref: "reference",
              staticClass: "user-container xh-form-border",
              class: [
                _vm.disabled ? "is_disabled" : "is_valid",
                { is_focus: _vm.showPopover },
              ],
              attrs: { slot: "reference", wrap: "wrap" },
              nativeOn: {
                click: function ($event) {
                  return _vm.focusClick.apply(null, arguments)
                },
              },
              slot: "reference",
            },
            [
              _vm._l(_vm.showDataValue, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "user-item text-one-line" },
                  [
                    _vm._v(_vm._s(item.realname) + "\n      "),
                    !_vm.disabled
                      ? _c("i", {
                          staticClass: "delete-icon el-icon-close",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.deleteuser(index)
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                )
              }),
              _vm._v(" "),
              _vm.dataValue.length > _vm.max
                ? _c("i", { staticClass: "el-icon-more" })
                : _vm._e(),
              _vm._v(" "),
              _c("i", {
                class: ["el-icon-arrow-up", { "is-reverse": _vm.showPopover }],
              }),
              _vm._v(" "),
              _vm.dataValue.length == 0
                ? _c("div", { staticClass: "add-item text-one-line" }, [
                    _vm._v(_vm._s(_vm.placeholder)),
                  ])
                : _vm._e(),
            ],
            2
          )
        : _vm._t("reference", null, { slot: "reference" }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }